import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';


pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PdfViewer = ({ fileUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [fileUrl2, setFileUrl] = useState(null);

  useEffect(() => {
    console.log(fileUrl);
    const fetchPdf = async () => {
      try {
        const res = await fetch(fileUrl);
        const contentType = res.headers.get("Content-Type");

        if (contentType !== "application/pdf") {
          throw new Error("Not a PDF file");
        }

        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        setFileUrl(url);
      } catch (err) {
        console.error("PDF Load Error", err);
        setError(true);
      }
    };

    fetchPdf();
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);
  };

  const onDocumentLoadError = (error) => {
    console.error("Error while loading PDF:", error);
    setError(true);
    setLoading(false);
  };

  const goToPrevPage = () => setPageNumber((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () =>
    setPageNumber((prev) => Math.min(prev + 1, numPages));

  return (
    <div
      style={{
        textAlign: "center",
        width: "100%",
        height: "100%",
        overflowX: "hidden",
      }}
    >
      {/* {loading && !error && <p>Loading PDF...</p>}
      {error && <p>Failed to load PDF.</p>}

      {!loading && !error && (
        <> */}
      {fileUrl2 && (
        <Document
          file={fileUrl2}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={onDocumentLoadError}
        >
          <Page
            pageNumber={pageNumber}
            // width={600}
            // scale={1} // Increase for better readability
            renderTextLayer={true} // Show selectable text
            renderAnnotationLayer={false} // Optional, removes extra annotations
          />
        </Document>
      )}

      <div style={{ marginTop: 10 }}>
        <button onClick={goToPrevPage} disabled={pageNumber <= 1}>
          Prev
        </button>
        <span style={{ margin: "0 10px" }}>
          Page {pageNumber} of {numPages}
        </span>
        <button onClick={goToNextPage} disabled={pageNumber >= numPages}>
          Next
        </button>
      </div>
      {/* </>
      )} */}
    </div>
  );
};

export default PdfViewer;
